import { get } from 'lodash';
import React from 'react';
import { GEGENSTAND_DER_FOERDERUNG, KOSTEN_ARTEN, KOSTEN_POSITION, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { enumT } from 'src/utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureAntragFinanzierungsPlanGlobal } from '../../global-structure/finanzierung-plan-antrag/TreeStructureAntragFinanzierungsPlanGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import FoerdervoraussetzungenAntragMobilitaetsplaene, {
	getFormStrucFoerdervoraussetzungenAntragMobilitaetsplaene,
} from './content/FoerdervoraussetzungenAntragMobilitaetsplaene';
import KostenPositionAntragMobilitaetsplaene, {
	getFormStrucKostenPositionAntragMobilitaetsplaene,
} from './content/KostenPositionAntragMobilitaetsplaene';
import KostenUebersichtAntragMobilitaetsplaene from './content/KostenUebersichtAntragMobilitaetsplaene';
import BegruendungAntragMobilitaetsplaeneCommon, {
	getFormStrucBegruendungAntragMobilitaetsplaeneCommon,
} from './content/projektbeschreibung-common/BegruendungAntragMobilitaetsplaene';
import AusgangssituationAntragMobilitaetsplaeneErstellung, {
	getFormStrucAusgangssituationAntragMobilitaetsplaeneErstellung,
} from './content/projektbeschreibung-erstellung/AusgangssituationAntragMobilitaetsplaeneErstellung';
import BeschreibungsDesVorhabensAntragMobilitaetsplaeneErstellung, {
	getFormStrucBeschreibungsDesVorhabensAntragMobilitaetsplaeneErstellung,
} from './content/projektbeschreibung-erstellung/BeschreibungsDesVorhabensAntragMobilitaetsplaeneErstellung';
import AusgangssituationAntragMobilitaetsplaeneUmsetzung, {
	getFormStrucAusgangssituationAntragMobilitaetsplaeneUmsetzung,
} from './content/projektbeschreibung-umsetzung/AusgangssituationAntragMobilitaetsplaeneUmsetzung';
import BeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung, {
	getFormStrucBeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung,
} from './content/projektbeschreibung-umsetzung/BeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung';
import ProjektDatenAntragMobilitaetsplaene, { getFormStrucProjektDatenAntragMobilitaetsplaene } from './content/ProjektdatenAntragMobilitaetsplaene';

// impoet schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

// Antrag zur Aufstellung eines nachhaltigen integrierten Mobilitätsplans
export const TreeStructureAntragMobilitaetsplaene = (
	application: any,
	kostenKategoriesGroup: any,
	readOnly: boolean,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
) => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);
	const hasFoerdervoraussetzungenComment = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Foerdervoraussetzungen_Pruefstatus.path,
	);

	let treeNodes: TreeNodeType[] = [
		// Allgemeinen Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektDatenAntragMobilitaetsplaene hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektDatenAntragMobilitaetsplaene(application),
			hasComment: hasCommentProjektdaten,
		},
		// Antragstellende Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Fördervoraussetzung
		{
			label: 'Fördervoraussetzungen',
			content: <FoerdervoraussetzungenAntragMobilitaetsplaene hasComment={hasFoerdervoraussetzungenComment} />,
			hasComment: hasFoerdervoraussetzungenComment,
			formStruc: getFormStrucFoerdervoraussetzungenAntragMobilitaetsplaene(application),
		},
		// Projektbeschreibung
		...ProjektbeschreibungStructure(application, readOnly),
		// KostenPosition
		...PersonalKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...SachKostenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		...EinnahmenStructure(application, kostenKategoriesGroup, readOnly, isKostenEditable),
		// Finanzierungsplan Global
		...TreeStructureAntragFinanzierungsPlanGlobal(application, isKostenEditable),
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlagen und Erklärung Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const ProjektbeschreibungStructure = (application: any, readOnly: boolean) => {
	// autofold/fold_next
	let nodes: TreeNodeType[] = [];

	const gegenStandDerFoerderung = get(
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0195191031_ng_Gegenstand_Der_Foerderung.path,
		'',
	);

	// Has comment für Erstellung
	const hasCommentAusgangsituation_E = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
	);
	const hasCommentBeschreibungDesVorhabens_E = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Erstellung_Pruefstatus.path,
	);
	const hasCommentBegruedung_E = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Pruefstatus.path,
	);

	// Has comment für Umsetzung
	const hasCommentAusgangssituation_U = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
	);
	const hasCommentBeschreibungDesVorhabens_U = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Pruefstatus.path,
	);
	const hasCommentBegruedung_U = checkIfHasComment(
		readOnly,
		application,
		P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Notwendigkeit_Pruefstatus.path,
	);

	const nodesMapping = {
		[GEGENSTAND_DER_FOERDERUNG.Erstellung]: [
			{
				label: 'Projektbeschreibung',
				content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
				hasComment: hasCommentAusgangsituation_E || hasCommentBeschreibungDesVorhabens_E || hasCommentBegruedung_E,
				children: [
					{
						label: 'Ausgangssituation',
						content: <AusgangssituationAntragMobilitaetsplaeneErstellung hasComment={hasCommentAusgangsituation_E} />,
						formStruc: getFormStrucAusgangssituationAntragMobilitaetsplaeneErstellung(application),
						hasComment: hasCommentAusgangsituation_E,
					},
					{
						label: 'Beschreibung des Vorhabens',
						content: <BeschreibungsDesVorhabensAntragMobilitaetsplaeneErstellung hasComment={hasCommentBeschreibungDesVorhabens_E} />,
						formStruc: getFormStrucBeschreibungsDesVorhabensAntragMobilitaetsplaeneErstellung(application),
						hasComment: hasCommentBeschreibungDesVorhabens_E,
					},
					{
						label: 'Begründung',
						content: <BegruendungAntragMobilitaetsplaeneCommon hasComment={hasCommentBegruedung_E} />,
						formStruc: getFormStrucBegruendungAntragMobilitaetsplaeneCommon(application),
						hasComment: hasCommentBegruedung_E,
					},
				],
			},
		],
		[GEGENSTAND_DER_FOERDERUNG.Umsetzung]: [
			{
				label: 'Projektbeschreibung',
				content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
				hasComment: hasCommentAusgangssituation_U || hasCommentBeschreibungDesVorhabens_U || hasCommentBegruedung_U,
				children: [
					{
						label: 'Ausgangssituation',
						content: <AusgangssituationAntragMobilitaetsplaeneUmsetzung hasComment={hasCommentAusgangssituation_U} />,
						formStruc: getFormStrucAusgangssituationAntragMobilitaetsplaeneUmsetzung(application),
						hasComment: hasCommentAusgangssituation_U,
					},
					{
						label: 'Beschreibung des Vorhabens',
						content: <BeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung hasComment={hasCommentBeschreibungDesVorhabens_U} />,
						formStruc: getFormStrucBeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung(application),
						hasComment: hasCommentBeschreibungDesVorhabens_U,
					},
					{
						label: 'Begründung',
						content: <BegruendungAntragMobilitaetsplaeneCommon hasComment={hasCommentBegruedung_U} />,
						formStruc: getFormStrucBegruendungAntragMobilitaetsplaeneCommon(application),
						hasComment: hasCommentBegruedung_U,
					},
				],
			},
		],
	};

	nodes = nodesMapping[gegenStandDerFoerderung];
	return nodes;
};
const PersonalKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	// autofold/fold_next
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Personalkosten)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Personalkosten),
				content: (
					<KostenPositionAntragMobilitaetsplaene
						kostenPosition={KOSTEN_POSITION.Ausgabe}
						kostenArt={KOSTEN_ARTEN.Personalkosten}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Personalkosten),
				formStruc: getFormStrucKostenPositionAntragMobilitaetsplaene(application, KOSTEN_POSITION.Ausgabe, KOSTEN_ARTEN.Personalkosten),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Personalkosten)} Übersicht`,
				content: <KostenUebersichtAntragMobilitaetsplaene kostenArt={KOSTEN_ARTEN.Personalkosten} />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const SachKostenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	// autofold/fold_next
	let nodes: TreeNodeType[] = [];
	if (
		get(
			application,
			P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0195191031_ng_Gegenstand_Der_Foerderung.path,
			'',
		) === GEGENSTAND_DER_FOERDERUNG.Erstellung &&
		get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Sachkosten)
	) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Sachkosten),
				content: (
					<KostenPositionAntragMobilitaetsplaene
						kostenPosition={KOSTEN_POSITION.Ausgabe}
						kostenArt={KOSTEN_ARTEN.Sachkosten}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Sachkosten),
				formStruc: getFormStrucKostenPositionAntragMobilitaetsplaene(application, KOSTEN_POSITION.Ausgabe, KOSTEN_ARTEN.Sachkosten),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Sachkosten)} Übersicht`,
				content: <KostenUebersichtAntragMobilitaetsplaene kostenArt={KOSTEN_ARTEN.Sachkosten} />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const EinnahmenStructure = (application: any, kostenKategoriesGroup: any, readOnly: boolean, hasCommentAusgabenUndFinanzierung?: boolean) => {
	// autofold/fold_next
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		nodes = [
			{
				label: enumT(KOSTEN_ARTEN.Eigenmittel),
				content: (
					<KostenPositionAntragMobilitaetsplaene
						kostenPosition={KOSTEN_POSITION.Einnahme}
						kostenArt={KOSTEN_ARTEN.Eigenmittel}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
				formStruc: getFormStrucKostenPositionAntragMobilitaetsplaene(application, KOSTEN_POSITION.Einnahme, KOSTEN_ARTEN.Eigenmittel),
			},
			{
				label: `${enumT(KOSTEN_ARTEN.Eigenmittel)} Übersicht`,
				content: <KostenUebersichtAntragMobilitaetsplaene kostenArt={KOSTEN_ARTEN.Eigenmittel} />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
